import { render, staticRenderFns } from "./audioTest.vue?vue&type=template&id=a313f19a&scoped=true"
import script from "./audioTest.vue?vue&type=script&lang=js"
export * from "./audioTest.vue?vue&type=script&lang=js"
import style0 from "./audioTest.vue?vue&type=style&index=0&id=a313f19a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a313f19a",
  null
  
)

export default component.exports